import i18next from 'i18n';
import { useTranslation } from 'react-i18next';
import { getLookerLocale } from '../constants';
import { useUserDetails } from 'core/app/AppContext';
import { useLocation, useHistory } from 'react-router-dom';

import {
  Grid,
  MainArea,
  Page,
  TopArea,
  Heading,
  P,
  Gap,
  Tabs,
  TabBar,
  Tab,
  TabView,
} from '@salecycle/ui-component-library';

import AppTopBar from 'core/ui/components/AppTopBar/AppTopBar';
import LookerEmbed from './LookerEmbed';

const getSiteUrl = () => {
  const match = window.location.pathname.match(/^\/sites\/([^/]+)\/dashboard/i);
  let currentMatch = match ? `/sites/${match[1]}` : '';
  if (currentMatch === '') {
    const match = window.location.pathname.match(/^\/brands\/([^/]+)\/dashboard/i);

    currentMatch = match ? `/brands/${match[1]}` : '';
  }
  if (currentMatch === '') {
    const match = window.location.pathname.match(/^\/groups\/([^/]+)\/dashboard/i);

    currentMatch = match ? `/groups/${match[1]}` : '';
  }
  return currentMatch;
};

const getDashboardRoute = (type: string, view: 'campaign' | 'legacy') => {
  const siteUrl = getSiteUrl();
  const base = '/dashboard/new_business_aggregates::';
  const params =
    '?Client=&Campaign+Name=&Aggregate+level=&Segment+ID+Name=&Cycle+Name=&Time+Period+Granularity=Week&Date+Range=30+day+ago+for+30+day&Currency+Exchange=GBP';

  const basePath = `${siteUrl}${base}${type}`;
  return view === 'campaign' ? `${basePath}__campaign_aggregates${params}` : basePath;
};

const DashboardPage = () => {
  const { username } = useUserDetails();
  const { t } = useTranslation('dashboard');
  const { pathname } = useLocation();
  const history = useHistory();

  const isBasket = pathname.includes('basket_abandonment');
  const isBrowse = pathname.includes('browse_abandonment');
  const isCampaign = pathname.includes('campaign_aggregates');

  const selectedTab = isCampaign ? (isBasket ? 'basket' : 'browse') : 'legacy';

  const navigateToTab = (tabId: string) => {
    if (tabId === 'legacy') {
      if (isBasket) history.push(getDashboardRoute('basket_abandonment', 'legacy'));
      else if (isBrowse) history.push(getDashboardRoute('browse_abandonment', 'legacy'));
    } else {
      const type = tabId === 'basket' ? 'basket_abandonment' : 'browse_abandonment';
      history.push(getDashboardRoute(type, 'campaign'));
    }
  };

  const renderTabs = () => {
    if (!isBasket && !isBrowse) return null;

    const content = (
      <Grid columnNumber={1} gridGap={30}>
        <LookerEmbed locale={getLookerLocale(i18next.language)} />
      </Grid>
    );

    return (
      <Tabs selectedTabId={selectedTab}>
        <TabBar>
          {isBasket && (
            <Tab tabId="basket" onClick={() => navigateToTab('basket')}>
              {t('tabs.basketAbandonments', 'Basket Abandonments')}
            </Tab>
          )}
          {isBrowse && (
            <Tab tabId="browse" onClick={() => navigateToTab('browse')}>
              {t('tabs.browseAbandonments', 'Browse Abandonments')}
            </Tab>
          )}
          <Tab tabId="legacy" onClick={() => navigateToTab('legacy')}>
            {t('tabs.legacyData', 'Legacy Data')}
          </Tab>
        </TabBar>

        <Gap bottom={30} />

        <TabView tabId={isBasket ? 'basket' : 'browse'}>{content}</TabView>
        <TabView tabId="legacy">{content}</TabView>
      </Tabs>
    );
  };

  const isTabbed = isBasket || isBrowse;
  const headingText = t('welcome.heading', { username, context: username ? 'name' : null });

  let subheadingKey = 'welcome.subtitle';
  if (isBasket) {
    subheadingKey = 'welcome.basketSubtitle';
  } else if (isBrowse) {
    subheadingKey = 'welcome.browseSubtitle';
  }
  const subheadingText = t(subheadingKey);

  return (
    <MainArea>
      <TopArea>
        <AppTopBar />
      </TopArea>
      <Page>
        <Heading>
          <span data-hj-suppress>{headingText}</span>
        </Heading>
        <P>{subheadingText}</P>
        <Gap bottom={20} />

        {isTabbed ? (
          renderTabs()
        ) : (
          <Grid columnNumber={1} gridGap={30}>
            <LookerEmbed locale={getLookerLocale(i18next.language)} />
          </Grid>
        )}
      </Page>
    </MainArea>
  );
};

export default DashboardPage;
